import validate from "/app/node_modules/.pnpm/nuxt@3.12.4_eslint@8.57.0_less@4.2.0_rollup@4.20.0_typescript@5.5.4_vite@5.4.0/node_modules/nuxt/dist/pages/runtime/validate.js";
import pt_45global from "/app/middleware/pt.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.12.4_eslint@8.57.0_less@4.2.0_rollup@4.20.0_typescript@5.5.4_vite@5.4.0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  pt_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  redirect: () => import("/app/middleware/redirect.ts")
}